import photo17 from '../images/gallery/photo_2024-05-23_21-57-55.jpg';
import photo7 from '../images/gallery/WhatsApp Image 2025-01-06 at 15.18.45_67c28873.jpg';
import photo2 from '../images/gallery/photo2.jpg';
import photo3 from '../images/gallery/photo_2024-05-23_21-58-23.jpg';
import photo4 from '../images/gallery/WhatsApp Image 2025-01-06 at 15.18.44_8b0f34ea.jpg';
import photo5 from '../images/gallery/photo_2024-05-23_21-58-45.jpg';
import photo6 from '../images/gallery/photo_2024-05-23_21-58-50.jpg';
import photo1 from '../images/gallery/WhatsApp Image 2025-01-06 at 15.18.44_2fc32e2f.jpg';
import photo8 from '../images/gallery/WhatsApp Image 2025-01-06 at 15.18.45_bfbfd205.jpg';
import photo16 from '../images/gallery/photo_2024-05-23_21-58-59.jpg';
import photo18 from '../images/gallery/photo12.jpeg';
import photo11 from '../images/gallery/photo13.jpg';
import photo12 from '../images/gallery/photo11.jpeg';
import photo13 from '../images/gallery/omovalleygallery2.jpg';
import photo14 from '../images/gallery/omovalleygallery3.jpg';
import photo15 from '../images/gallery/omovalleygallery1.jpg';
import photo9 from '../images/gallery/WhatsApp Image 2025-01-06 at 15.18.44_97a88069.jpg';
import photo10 from '../images/gallery/WhatsApp Image 2025-01-06 at 15.18.45_c4aa91bf.jpg';
import photo19 from '../images/gallery/WhatsApp Image 2025-01-13 at 19.45.06_fa389f21.jpg';
import photo20 from '../images/gallery/WhatsApp Image 2025-01-13 at 19.46.45_56039cf3.jpg';
import photo21 from '../images/gallery/gallery4.jpg';
import photo22 from '../images/gallery/gallery5.jpg';
import photo23 from '../images/gallery/gallery6.jpg';
import photo24 from '../images/gallery/gallery7.jpg';
import photo25 from '../images/gallery/gallery8.jpg';
import photo26 from '../images/gallery/gallery9.jpg';
import photo27 from '../images/gallery/gallery10.jpg';
import photo28 from '../images/gallery/gallery11.jpg';
import photo29 from '../images/gallery/gallery12.jpg';
import photo30 from '../images/gallery/gallery13.jpg';
import photo31 from '../images/gallery/gallery14.jpg';
import photo32 from '../images/gallery/gallery15.jpg';
import photo33 from '../images/gallery/gallery16.jpg';
import photo34 from '../images/gallery/gallery17.jpg';
import photo35 from '../images/gallery/gallery18.jpg';
import photo36 from '../images/gallery/gallery19.jpg';




export const photos = [
  {
    src: photo1,
    width: 2,
    height: 0.5,
    location: 'Simien Mountains',
  },
  {
    src: photo2,
    width: 2,
    height: 0.5,
    location: 'Lalibela',
  },
  {
    src: photo3,
    width: 2,
    height: 1,
  },
  {
    src: photo4,
    width: 2,
    height: 1,
  },
  {
    src: photo5,
    width: 2,
    height: 1,
  },
  {
    src: photo6,
    width: 2,
    height: 1,
  },
  {
    src: photo7,
    width: 4,
    height: 3,
  },
  {
    src: photo8,
    width: 2,
    height: 1,
  },
  {
    src: photo9,
    width: 4,
    height: 3,
  },
  {
    src: photo10,
    width: 2,
    height: 1,
  },
  {
    src: photo11,
    width: 2,
    height: 1,
  },
  {
    src: photo12,
    width: 2,
    height: 1,
  },
  {
    src: photo13,
    width: 2,
    height: 1,
  },
  {
    src: photo14,
    width: 2,
    height: 1,
  },
  {
    src: photo15,
    width: 2,
    height: 1,
  },
  {
    src: photo16,
    width: 2,
    height: 1,
  },
  {
    src: photo17,
    width: 2,
    height: 1,
  },
  {
    src: photo18,
    width: 2,
    height: 1,
  },
  {
    src: photo19,
    width: 2,
    height: 1,
  },
  {
    src: photo20,
    width: 2,
    height: 1,
  },
  {
    src: photo21,
    width: 2,
    height: 1,
  },
  {
    src: photo22,
    width: 2,
    height: 1,
  },
  {
    src: photo23,
    width: 2,
    height: 1,
  },
  {
    src: photo24,
    width: 2,
    height: 1,
  },
  {
    src: photo25,
    width: 2,
    height: 1,
  },
  {
    src: photo26,
    width: 2,
    height: 1,
  },
  {
    src: photo27,
    width: 2,
    height: 1,
  },
  {
    src: photo28,
    width: 2,
    height: 1,
  },
  {
    src: photo29,
    width: 2,
    height: 1,
  },
  {
    src: photo30,
    width: 2,
    height: 1,
  },
  {
    src: photo31,
    width: 2,
    height: 1,
  },
  {
    src: photo32,
    width: 2,
    height: 1,
  },
  {
    src: photo33,
    width: 2,
    height: 1,
  },
  {
    src: photo34,
    width: 2,
    height: 1,
  },
  {
    src: photo35,
    width: 2,
    height: 1,
  },
  {
    src: photo36,
    width: 2,
    height: 1,
  },
];
